import React from 'react';
import { ExternalLink, Play } from 'lucide-react';

const VideoCard = ({ video }) => {
  if (!video || !video.video_id) return null;

  const thumbnailUrl = `https://img.youtube.com/vi/${video.video_id}/mqdefault.jpg`;

  return (
    <a
      href={video.url || `https://www.youtube.com/watch?v=${video.video_id}`}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex-shrink-0 w-56 rounded-lg border border-beige bg-white overflow-hidden hover:border-sage hover:shadow-md transition-all duration-300"
      data-testid={`video-card-${video.video_id}`}
    >
      <div className="relative">
        <img
          src={thumbnailUrl}
          alt={video.title || 'Video tutorial'}
          className="w-full h-28 object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all shadow-lg">
            <Play size={18} className="text-white ml-0.5" fill="white" />
          </div>
        </div>
      </div>
      <div className="p-3">
        <p className="text-xs font-medium text-charcoal line-clamp-2 leading-tight mb-1.5">
          {video.title || 'Watch Tutorial'}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-sage font-medium truncate">
            {video.creator || 'Creator'}
          </span>
          <ExternalLink size={12} className="text-gray-soft flex-shrink-0 ml-1" />
        </div>
      </div>
    </a>
  );
};

export default VideoCard;
